import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type JiraProjectType,
} from './__generated__/specialOfferSixtyModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	projectType: JiraProjectType;
};

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-special-offer-sixty-modal" */ './special-offer-sixty-modal'
			),
		{
			moduleId: 'edition-awareness-special-offer-sixty-modal',
		},
	),
	getPreloadProps: ({ cloudId, projectType }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			specialOfferSixtyModalQuery: {
				parameters,
				variables: {
					cloudId,
					projectType,
				},
			},
		},
	}),
});
